import { useState } from 'react';
import { useSnackbar } from 'notistack';
import { getResponseMessage } from '../../../../../utils/utils';
import { useFormatMessage } from '../../../../../hooks';
import { createOrder } from '../../../../../crud/orders.crud';
import { ICreateOrder, IOrderResponse } from '../../../../../interfaces/order';

export const useCreateOrder = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loadingCreated, setLoading] = useState(false);
  const [successCreated, setSuccess] = useState(false);
  const [createdOrder, setOrder] = useState<IOrderResponse>();
  const fm = useFormatMessage();
  const createOrderTaxi = (data: ICreateOrder, user_id?: number) => {
    setLoading(true);
    createOrder(data, user_id)
      .then(res => {
        setSuccess(true);
        setOrder(res.data.data);
      })
      .catch(e => {
        enqueueSnackbar(`${fm('ERROR')}: ${getResponseMessage(e)}`);
      })
      .finally(() => {
        setLoading(false);
        setTimeout(() => {
          setSuccess(false);
          setOrder(undefined);
        }, 100);
      });
  };

  return { createOrderTaxi, successCreated, loadingCreated, createdOrder };
};
